module.exports = __webpack_public_path__ + "img/img-zy.033a4ae1.png";